import React, { useState } from 'react';

import cx from 'classnames';

import EditableText from 'components/shared/EditableText';
import Icon from 'components/shared/Icon';
import Pencil from 'components/shared/Icon/icons/Pencil';

import styles from './index.module.css';
import { ITitleProps } from './types';

function Title({ value, onChange, readOnly }: ITitleProps) {
  const [isEditTitle, setIsEditTitle] = useState(false);

  return (
    <div className={cx(styles.title, 'custom-accordion-item-title')} data-block>
      {isEditTitle && !readOnly ? (
        <div onClick={(e) => e.stopPropagation()}>
          <EditableText
            text={value}
            onChange={onChange}
            onBlur={() => {
              setIsEditTitle(false);
            }}
            placeholder="Section name"
            autofocus
          />
        </div>
      ) : (
        value
      )}

      {!isEditTitle && !readOnly && (
        <Icon
          component={Pencil}
          className={cx(styles.icon, styles.editIcon, 'custom-accordion-item-edit')}
          width="20px"
          height="16px"
          stroke="#3F3C43"
          onClick={(e) => {
            e.stopPropagation();
            setIsEditTitle(true);
          }}
        />
      )}
    </div>
  );
}

export default Title;
